document.addEventListener('DOMContentLoaded', function() {
    let colorSwatches = document.querySelectorAll('.color-swatch');
    colorSwatches.forEach(function(swatch) {
        swatch.addEventListener('click', function() {
            if (swatch.classList.contains('color-swatch--selected')) {
                swatch.classList.remove('color-swatch--selected');

                let colorImage = swatch.closest('.product-card-wrapper').querySelector('.card__media-variant--selected');
                let mainImage = swatch.closest('.product-card-wrapper').querySelector('.card__media--hidden');
                colorImage.classList.remove('card__media-variant--selected');
                mainImage.classList.remove('card__media--hidden');
                return;
            }

            let currentColorSwatches = swatch.closest('.product-card-wrapper').querySelectorAll('.color-swatch');

            currentColorSwatches.forEach(function(swatch) {
                swatch.classList.remove('color-swatch--selected');
            });
            swatch.classList.toggle('color-swatch--selected');

            let selectedColor = swatch.dataset.color;
            let mainImage = swatch.closest('.product-card-wrapper').querySelector('.card__media:not(.card__media-variant)');
            let colorImage = swatch.closest('.product-card-wrapper').querySelector(`.card__media-variant[data-color="${selectedColor}"]`);
            let previousColorImage = swatch.closest('.product-card-wrapper').querySelector('.card__media-variant--selected');
            if (previousColorImage) {
                previousColorImage.classList.remove('card__media-variant--selected');
            }
            colorImage.classList.add('card__media-variant--selected');
            mainImage.classList.add('card__media--hidden');
        });
    });

});